import { useEffect, useContext } from "react";
import { Block } from "@models/ISchema";
import { useGetBlocksRanges } from "@services/collections/blocks/blocksServices";
import { UseGetBlocksRangesReturn } from "@services/types/blocks/blocksTypes";
import { AppContext } from "../context/EditSessionsContext";
import { Types } from "../context/linkData.reducer";

interface useGetBlocksProps {
  shoudSetContext?: boolean;
}

export const useGetBlocks = (props?: useGetBlocksProps): UseGetBlocksRangesReturn => {
  const { shoudSetContext = true } = props ?? {};
  const { state, dispatch } = useContext(AppContext);
  const [{ dataStart, dataEnd, rawBlocks, isLoading }, getBlocksInfo] = useGetBlocksRanges();

  useEffect(() => {
    if (!state.link?.blockRanges && dataStart && dataEnd && shoudSetContext) {
      dispatch({
        type: Types.BlockRanges,
        payload: {
          start: dataStart,
          end: dataEnd,
        },
      });
    }
  }, [dataStart, dataEnd, shoudSetContext]);

  useEffect(() => {
    if (rawBlocks && rawBlocks.length > 0 && shoudSetContext) {
      const key = (block: Block) => `${block.startingTime} - ${block.endingTime}`;

      // define unique start-end blocks
      const [uniqueRawBlocks] = rawBlocks.reduce(
        ([uniques, uniqueTable], block) => {
          if (key(block) in uniqueTable) return [uniques, uniqueTable];
          uniqueTable[key(block)] = true;
          (uniques as Block[]).push(block);
          return [uniques, uniqueTable];
        },
        [[], {}],
      );

      dispatch({
        type: Types.RawBlocks,
        payload: uniqueRawBlocks,
      });
    }
  }, [rawBlocks, shoudSetContext]);

  return [
    {
      dataStart,
      dataEnd,
      rawBlocks,
      isLoading,
    },
    getBlocksInfo,
  ];
};

export default useGetBlocks;
